<script setup>
import { onMounted } from "vue";
import Chart from "chart.js/auto";

const props = defineProps({
    id: {
        type: String,
        required: true,
    },
    height: {
        type: String,
    default: "300",
    },
    title: {
        type: String,
    default: "",
    },
    description: {
        type: String,
    default: "",
    },
    chart: {
        type: Object,
        required: true,
        labels: Array,
        datasets: {
            type: Array,
            label: String,
            data: Array,
        },
    },
});

onMounted(() => {
    var lineChart = document.getElementById(props.id).getContext("2d");

    let chartStatus = Chart.getChart(props.id);
    if (chartStatus != undefined) {
        chartStatus.destroy();
    }

    new Chart(lineChart, {
        type: 'pie',
        data: {
            labels: props.chart.labels,
            datasets: props.chart.datasets,
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: true,
                },
            },
            interaction: {
                intersect: false,
                mode: "index",
            },
        /*  scales: {
                y: {
                    grid: {
                        drawBorder: false,
                        display: true,
                        drawOnChartArea: true,
                        drawTicks: false,
                        borderDash: [5, 5],
                    },
                    border: {
                        dash: [5, 5],
                    },
                    ticks: {
                        display: true,
                        padding: 10,
                        color: "#fbfbfb",
                        font: {
                            size: 11,
                            family: "Open Sans",
                            style: "normal",
                            lineHeight: 2,
                        },
                    },
                },
                x: {
                    grid: {
                        drawBorder: false,
                        display: false,
                        drawOnChartArea: false,
                        drawTicks: false,
                        borderDash: [5, 5],
                    },
                    border: {
                        dash: [5, 5],
                    },
                    ticks: {
                        display: true,
                        color: "#ccc",
                        padding: 20,
                        font: {
                            size: 11,
                            family: "Open Sans",
                            style: "normal",
                            lineHeight: 2,
                        },
                    },

                } 
            }  */
        }
    });
});
</script>
<template>
<div class="card z-index-2">
<div class="pb-0 card-header mb-0">

<div class="row">
<div class="col-md-12">
<h6>{{ props.title }}</h6>
<p v-if="props.description" class="text-sm" v-html="props.description" />
</div>
</div>

</div>
<div class="p-3 card-body">
<div class="chart">
<canvas
:id="props.id"
class="chart-canvas"
:height="props.height"
></canvas>
</div>
</div>
</div>
</template>
